export const getTotalPurchasePriceInPennies = (numPressReleases, pricePerPressRelease) => {
  return numPressReleases * pricePerPressRelease;
};

export const getProduct = (packageObject, quantity) => {
  // Given an packageObject, returns the inner eventObject
  // packageObject is an object from the packages array
  const product = {
    v: 11, // seer product schema version
    id: packageObject.pk,
    name: packageObject.display_name,
    quantity,
    price: packageObject.price_per_press_release / 100,
    position: packageObject.pk,
  };
  return product;
};

export const getEventObject = (packageObject, paymentIntentId, quantity) => {
  const product = getProduct(packageObject, quantity);
  // eslint-disable-next-line max-len
  const value = getTotalPurchasePriceInPennies(quantity, packageObject.price_per_press_release) / 100;
  const dataObj = {
    value, // The total price value of all items added to the cart.
    transaction_id: paymentIntentId,
    products: [product],
    type: 'Package',
  };

  if (window.dataLayer) {
    dataObj.site = window.dataLayer[0].site;
  }

  return dataObj;
};
